import parseHtml from 'html-react-parser';
import { BIPOLAR } from 'components/shared/types';
import { IQuestion } from 'components/assessment-flow/types';
import MobileImage from '../DepressionAssessmentResult/images/business-main-mobile.png';
import DesktopImage from '../DepressionAssessmentResult/images/business-main-desktop.png';

export const BIPOLAR_TREATMENT_OPTIONS = [
  {
    title: 'Medication from licensed prescribers',
    description:
      'Explore medication options with a licensed prescriber who will determine whether a prescription is appropriate.'
  },
  {
    title: 'Highly-rated therapists',
    description: parseHtml(
      'We thoroughly vet each of our therapists and only invite select practitioners to join Cerebral. 99% of our team has a <strong>4.8 rating.</strong>'
    )
  },
  {
    title: 'Cognitive behavioral therapy (CBT)',
    description:
      'CBT helps identify specific challenges in your thought patterns and develop skills to respond to them more effectively. One of the most common and effective forms of talk therapy.'
  }
];

export const negativeDescription =
  'Your results suggest you are not experiencing signs of bipolar disorder. However, if you believe you are or if you want to explore mental health services, you should meet with a qualified medical professional for a comprehensive evaluation.';
export const positiveDescription =
  'Your results suggest that you are experiencing some signs of bipolar disorder. The results are not a diagnosis and you should meet with a qualified medical professional for a comprehensive evaluation.';

export const assessmentData = {
  assessmentScore: {
    title: 'Your bipolar screener results are:',
    description:
      'Your results suggest that you are experiencing some signs of bipolar disorder. The results are not a diagnosis and you should meet with a qualified medical professional for a comprehensive evaluation.',
    serviceLine: BIPOLAR,
    buttonText: 'Continue'
  },
  assessmentTreatment: {
    title: 'Continue with basic info to see if treatment is right for you',
    description:
      'The professionals at Cerebral can provide a medical evaluation and appropriate treatment options to help you take control of your mental health.',
    ctaText: 'Continue',
    subscript: 'Next steps',
    treatmentOptions: BIPOLAR_TREATMENT_OPTIONS,
    cerebralRx: parseHtml(
      'With CerebralRx, medication is shipped directly to you and can cost up to <strong>80% less</strong> than retail prices.'
    ),
    image: {
      desktop: DesktopImage,
      mobile: MobileImage
    }
  },
  steps: [
    {
      title: 'Basic info',
      description:
        'Create your account with some basic information — name, contact info, and some context about your experience with mental health care.'
    },
    {
      title: 'Choose a treatment plan',
      description:
        'Learn more about therapy and medication services, then choose the treatment plan that is right for you. You can always change your plan later for any reason.'
    },
    {
      title: 'Choose a clinician + book a session',
      description:
        'See all available clinicians in your area by specialty and availability. You can read their bios, see their full calendars, and book your first session.'
    }
  ]
};

export const mdqInterpretation = (questions: IQuestion[]) => {
  const selectedAnswereds = questions.map(
    question => question.selectedOption?.title
  );
  const yesAnswered = selectedAnswereds.filter(answer => answer === 'Yes');

  if (
    yesAnswered.length > 6 &&
    selectedAnswereds[13] === 'Yes' &&
    ['Moderate Problem', 'Serious Problem'].includes(
      selectedAnswereds[14] || ''
    )
  ) {
    return 'Positive';
  }

  return 'Negative';
};
